import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

// UI
import { Box, Button, Flex, Heading, Spacer } from '@chakra-ui/react'

import ContributorGroupDetailModal from '../components/ContributorGroupDetailModal'

//Hooks

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//helper

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'
import { createColumnHelper } from '@tanstack/react-table'

import getContributorGroupTableColumns from '../constants/contributorGroupTableColumns'
import { useContributorGroup } from '../useContributorGroup'
import { LoadingSection } from '@/components/Elements'
const ContributorGroupListPage = () => {
  // Table State
  const [modalDetail, setModalDetail] = useState({
    show: false,
    isCreate: false,
    detail: {},
  })

  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:contributorGroups`, {})
  const query = convertTableStateToQuery(storedTableState)

  const { useFetchAllContributorGroups, useUpdateContributorGroup, useRemoveContributorGroup } = useContributorGroup()

  const removeContributorGroup = useRemoveContributorGroup()
  const updateContributorGroup = useUpdateContributorGroup()
  const dispatch = useDispatch()
  const columnHelper = createColumnHelper()

  // Hooks
  const { data: contributorGroupsResponse, isLoading } = useFetchAllContributorGroups(query)

  const handleAddContributorGroup = () => {
    setModalDetail({
      show: true,
      isCreate: true,
      detail: {},
    })
  }

  const handleOnRowClick = (row) => {
    setModalDetail({
      show: true,
      isCreate: false,
      detail: {
        type: row?.original?.type,
        name: row?.original?.name,
        defaultUser: row?.original?.defaultUser?._id || '',
        _id: row?.original?._id,
        requiredInOffer: row?.original?.requiredInOffer === 'yes',
      },
    })
  }

  const handleDelete = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await removeContributorGroup.mutateAsync(id)
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, removeContributorGroup]
  )
  const handleActivate = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())

        await updateContributorGroup.mutateAsync({ id, data: { isDeleted: false } })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, updateContributorGroup]
  )

  const defaultColumns = getContributorGroupTableColumns({
    handleActivate,
    handleDelete,
  })

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <ContributorGroupDetailModal modalDetail={modalDetail} setModalDetail={setModalDetail} />

      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <Flex p={5} borderBottom="1px solid #d8dbe0">
          <Heading>Contributor Groups</Heading>

          <Spacer />
          <Button colorScheme="blue" onClick={handleAddContributorGroup}>
            Add
          </Button>
        </Flex>
        <Box p={5} overflow="scroll">
          <FullTable
            data={contributorGroupsResponse?.data ? contributorGroupsResponse.data : []}
            rowCount={contributorGroupsResponse?.count}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
          />
        </Box>
      </Box>
    </>
  )
}

export default ContributorGroupListPage
